<template>
  <div>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-toolbar color="warning">
        <v-toolbar-title class="white-text">
          <span class="white--text"> {{ 'Tur Alt Paketler' }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text class="blockquote">
          {{ $t('Are-you-sure-want-delete') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="deleteMasterTur()"> {{ $t('Delete') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{dialog_baslik}}</v-toolbar-title>

            </v-toolbar>
          </v-flex>
          <v-card-text>
            <v-flex pa-1 xs12 sm12 md12>
              <v-card>
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-form ref="formmasterpaket" v-model="validmasterpaket" lazy-validation>
                      <v-layout wrap>

                      

                        <v-flex xs12 sm12 md12>
                          <tarihim :etiket="$t('Date')" 
                                v-model="eklenecektarih" style="width: 100%;"
                               ></tarihim>
                        </v-flex>
                       
                         
                         
                      
                      
                      

                      </v-layout>
                    </v-form>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
             <v-btn color="blue darken-1" flat @click="vazgec()">{{$t('Cancel')}}</v-btn>
             <v-btn :disabled="!sayfayetki.Save" color="info" slot="activator" @click="Kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t("save_button")}}</span>
                  </span>
              </v-btn>
           
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>
      <v-toolbar size="120px" dark color="info">
        <v-toolbar-title>{{'Paket Tur Alt Paketler'}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
        </v-text-field>


        <v-tooltip bottom>
          <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="yeniekle()" flat> <span
              class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{'Alt Paket Ekle'}} </span>
            </span>
            <v-icon right dark>add_box</v-icon>

          </v-btn>
          <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
          <span v-if="sayfayetki.Save"> {{ $t('Add-v2', { value: 'Master-Tur'}) }}</span>
        </v-tooltip>





      </v-toolbar>
    </v-layout>
    <v-card color="grey lighten-5" flat>
     

      
      <v-flex xs12 sm12 md12>
        <v-form ref="formgunluksatis" lazy-validation>
          <v-card flat class="pa-3">
            <v-layout row>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md4>
                    <v-select
                            label="Master Paket Seçin"
                            v-model="selectedmasterid"
                            item-text="TurAdi"
                            item-value="Id"
                            :items="masteritems"
                            
                          ></v-select>
                  </v-flex>
                

                  <v-flex xs12 sm6 md4>
                    <v-layout>
                      <v-btn color="info" @click="getlist()"  fab small dark>
                        <v-icon>search</v-icon>
                      </v-btn>

                    
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm0 md1>
                                </v-flex>
 
                            
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-form>
      </v-flex>

     

     
    </v-card>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="altpaketitems"
        :search="search3">
        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item.TurKodu)" item>
            <td class="text-xs-left">{{ props.item.TurKodu }}</td>
            <td class="text-xs-left">{{ props.item.TurAdi }}</td>
            <td class="text-xs-left">{{ props.item.Kategori.isim }}</td>
            <td class="text-xs-left">{{ props.item.UrunGrubu.isim }}</td>
            <td class="text-xs-left">{{ props.item.Gunduz }}</td>
            <td class="text-xs-left">{{ props.item.Gece }}</td>
            <td class="text-xs-left">{{ props.item.Kontenjan }}</td>
            <td class="text-xs-left">{{ props.item.Notlar }}</td>
            <td class="text-xs-right">
                      <v-btn
                        color="info"
                        @click="gitUpdate(props.item)"
                        icon small flat
                      >
                        <v-icon>search</v-icon>
                      </v-btn>
                      <v-btn  @click="" icon small flat>
                <v-icon color="warning"  @click="deleteDialogOpen(props.item)">delete</v-icon>
              </v-btn>
                    </td>
                 
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          {{ $t('No-records-searched-for', { value: search3}) }} 
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
 
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import tool from "../coper/tools";
  import tarihim from "@/components/app/customcomp/tarihim.vue"
  export default {
    data() {
      return {
        insertid:null,
        tmpalttur:null,
        deleteDialog: false,
        deleteId:0,
        validbanka: true,
        passwordRules: [
          v => !!v || this.$t('This-space-cannot-left-blank'),
          v => (v && v.length < 5) || this.$t('Maximum-4-characters')
        ],
        sayfayetki: {
          Screen: true,
          Update: true,
          Save: true,
          Delete: true,
          Status: true,
          Message: null,
          islem: 0,
        },
        headers: [{
            text: 'Tur Kodu',
            
          },
          {
            text: 'Tur Adı',
            value: 'TurAdi'
          },
          {
            text: 'Ürün Grubu',
            value: 'UrunGurubuAdi'
          },
          {
            text: 'Kategori',
            value: 'KategoriAdi'
          },
          {
            text: 'Gündüz',
            value: 'Gunduz'
          },
          {
            text: 'Gece',
            value: 'Gee'
          },
          {
            text: 'Kontenjan',
            value: 'Kontenjan'
          },
          {
            text: 'Notlar',
            value: 'Notlar'
          },
          {
            text: 'İşlem',
          
          }

        ],
        loading: false,
        color: 'orange darken-4',
       
        search3: '',
        search: null,
        select: [],
        selected: '',
        masteritems: [],
        selectedmasterid:null,
        altpaketitems:[],
        eklenecektarih:null,
        m: false,
        k: false,
        dialog: false,
        
        cari: '',
        state: [],
        dialog_baslik: '',
        codegorunum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        bankakod: '',
        bankaadi: '',
        progress: false,
        dictionary: {
          custom: {
            bankakod: {
              required: () => this.$t('This-space-cannot-left-blank'),
              max: () => this.$t('Must-least-4-digits'),
            },
            bankaadi: {
              required: () => this.$t('This-space-cannot-left-blank'),
            }
          }
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    watch: {
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)

      // this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.MasterTurList();


    
    },
    methods: {
      deleteDialogOpen(val) {
      this.deleteDialog = true;
      this.deleteId = val.Id;
    },
    deleteMasterTur(id)
    {
      let params = {
        Id: this.deleteId,
      };
      tool.http_post(this, "PaketDelete", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.getlist();
           this.deleteDialog=false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );

    },
      gitUpdate(val)
      {

       
        var url = '#/pakettur/turaltpaketislem/islem?id=' +  val.Id;

window.open(url, '_self')
      },
      yeniekle() {
        if (this.selectedmasterid==null)
      {
        return;
      }
      this.dialog_baslik='Yeni Alt Paket';
           this.dialog=true;
        },
        getlist()
        {
          let params = {
    MasterTurId: this.selectedmasterid,
    tumSirketler: false,
    sayfaAdi: null,
  };
  tool.http_post(this, "MasterTurAltPaketList", params).then(
    (response) => {
      if (response.body.Status == true) {
        this.altpaketitems=response.body.data;
        console.log("MasterTurAltPaketList response :");
        console.log(response.body);
      } else {
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = "Hata Oluştu, tekrar deneyiniz";
      this.snackbar = true;
    }
  );

        },
        MasterTurList() {
          this.loadingvmodel=true;
      let params = {
        Ref: 0,
        TurKodu: null,
        TurAdi: null,
        Notlar: null,
        Gece: 0,
        Gunduz: 0,
        Aktif: false,
        KategoriId: 0,
        UrunGrubuId: 0,
        Kontenjan: 0,
        KayitTarihi: "2020-01-01T00:00:00",
        tumSirketler: false,
        sayfaAdi: null,
      };
      tool.http_post(this, "MasterTurList", params).then(
        (response) => {
          if (response.body.Status == true) {
           
            this.masteritems=response.body.data;
            this.loadingvmodel=false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.loadingvmodel=false;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.loadingvmodel=false;
        }
      );
    },

     
      deletemastertur: deletemastertur,
      masterturekle: masterturekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    components: {
      yetkidialog,
      tarihim
    },
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
    this.search = ''
    
  }

function altturekle()
{
 
}
  function Kaydet() {


  if (this.eklenecektarih==null)
  {
    return;
  }
  var credentials = JSON.parse(window.localStorage.getItem('credentials'));
  let paramscopy = {
    MasterTurId: this.selectedmasterid,
    Tarih: this.eklenecektarih,
    tumSirketler: false,
    sayfaAdi: null,
  };
  tool.http_post(this, "PaketKopyala", paramscopy).then(
    (response) => {
      if (response.body.Status == true) {
        this.tmpalttur=response.body.data;




        var prmprogramlar={
                FiyatGruplari:[],
              };


             

        this.tmpalttur.Program.FiyatGruplari.forEach((value, index) => {
          var grup={Id:value.Id,FiyatGrubuId:value.FiyatGrubu.id,silinecek:"false",AltGruplar:[]};
          value.AltGruplar.forEach((valuealt,indexalt)=>{
         
            var altgrup={Id:valuealt.Id,AltGrupId:valuealt.AltGrup.id,Tarihler:[],
              SatisFiyat: {
                                TekKisiFiyati: valuealt.SatisFiyat.TekKisiFiyati,
                                IkinciKisideTekKisiFiyati: valuealt.SatisFiyat.IkinciKisideTekKisiFiyati,
                                UcuncuKisiFiyati: valuealt.SatisFiyat.UcuncuKisiFiyati,
                                CocukFiyati: valuealt.SatisFiyat.CocukFiyati,
                                BebekFiyati: valuealt.SatisFiyat.BebekFiyati,
                                ParaBirimi: valuealt.SatisFiyat.ParaBirimi,
                                Kur: valuealt.SatisFiyat.Kur
                            }
            };

            valuealt.Tarihler.forEach((valuetarih,indextarih)=>{
              var tarihprm={Tarih:valuetarih.Tarih,Isler:[]};
              valuetarih.Isler.forEach((valueis,indexis)=>{
               tarihprm.Isler.push ({Id:valueis.Id,IsTipi:valueis.IsTipi,silinecek:"false"});
              
            })
altgrup.Tarihler.push(tarihprm);

            })

            grup.AltGruplar.push(altgrup);
          }
        
        )
          prmprogramlar.FiyatGruplari.push( grup );
});

        let params = {
    MasterTurId: this.selectedmasterid,
    TurKodu: this.tmpalttur.TurKodu,
    TurAdi: this.tmpalttur.TurAdi,
    Notlar: this.tmpalttur.Notlar,
    Gece: this.tmpalttur.Gece,
    Gunduz: this.tmpalttur.Gunduz,
    Aktif: true,
    KategoriId: this.tmpalttur.Kategori.id,
    UrunGrubuId: this.tmpalttur.UrunGrubu.id,
    Kontenjan: this.tmpalttur.Kontenjan,
    Program: prmprogramlar,
    tumSirketler: false,
    sayfaAdi: null,
  };
 
  tool.http_post(this, "PaketInsert", params).then(
    (response) => {
      if (response.body.Status == true) {
        this.insertid=response.body.data.Id;
        console.log("PaketInsertControl response :");
        console.log(response.body.data);
        var url = '#/pakettur/turaltpaketislem/islem?id=' +  this.insertid;
        window.open(url, '_self')
      } else {
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = "Hata Oluştu, tekrar deneyiniz";
      this.snackbar = true;
    }
  );
       

        
      } else {
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = "Hata Oluştu, tekrar deneyiniz";
      this.snackbar = true;
    }
  );
       
  console.log("PaketKopyala response :");
  console.log(this.tmpalttur);
 

 

  }
  function masterturekle() {

    this.dialog = true
    this.MasterTur = {}
    this.dialog_baslik = 'Ekle'
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {

  }

  function deletemastertur() {
    if (window.confirm('Seçili Turu silmek istediğinizden emin misiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    
    }
  }

  function guncelle() {
   
  }
</script>

<style>

</style>